import Icon from '../components/Icon.vue'

Icon.register({
  'swimming-pool': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 416c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-16c-38.6 0-72.7-12.2-96-31.8-23.3 19.6-57.4 31.8-96 31.8s-72.7-12.2-96-31.8c-23.3 19.6-57.4 31.8-96 31.8s-72.7-12.2-96-31.8c-23.3 19.6-57.4 31.8-96 31.8h-16c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h16c26 0 45.8-8.4 56.1-17.9 8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9s45.8-8.4 56.1-17.9c8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9s45.8-8.4 56.1-17.9c8.9-8.2 19.7-14.1 31.8-14.1h16.3c12.1 0 22.9 5.9 31.8 14.1 10.3 9.5 30 17.9 56.1 17.9h16zM224 384c-19.1 0-30.9-6.2-34.4-9.4-9.2-8.5-19.2-14.3-29.6-18.1v-228.5c0-52.9 43.1-96 96-96s96 43.1 96 96v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.6-14.4-32-32-32s-32 14.4-32 32v96h192v-96c0-52.9 43.1-96 96-96s96 43.1 96 96v16c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-16c0-17.6-14.4-32-32-32s-32 14.4-32 32v228.5c-10.4 3.7-20.4 9.6-29.6 18.1-3.5 3.3-15.3 9.4-34.4 9.4v-96h-192v96z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/swimming-pool.js
// module id = 1972
// module chunks = 0